/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
import React from "react";
import Dropdown from "../../../../../components/common/new/Dropdown/Dropdown";
import InputField from "../../../../../components/common/new/InputField/InputField";
import Typography from "../../../../../components/common/new/Typography/Typography";
import Styles from "./LabelInputField.styles";
import { AUTOCOMPLETE, DROPDOWN, TEXTFIELD } from "../../../../../contants";
import AsyncAutoComplete from "../../../../../components/common/new/AutoCompleteDropdown/AsyncAutoComplete";

function LabelInputField({ sideLabel, type, hidden, ...props }) {
  if (hidden) {
    return null;
  }

  return (
    <Box style={Styles.inputContainer}>
      <Box style={Styles.label}>
        <Typography variant="small" color="#8c8c8c">
          {sideLabel}
        </Typography>
      </Box>
      <Box style={Styles.action}>
        {type === DROPDOWN ? (
          <Dropdown {...props} />
        ) : type === TEXTFIELD ? (
          <InputField {...props} />
        ) : type === AUTOCOMPLETE ? (
          <AsyncAutoComplete {...props} />
        ) : (
          <Typography variant="small" color="#515151">
            {props.value}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
export default LabelInputField;
